<template>
  <b-form-group
    label="İçerik Başlık"
    label-for="title_content"
  >
    <validation-provider
      #default="{ errors }"
      name="İçerik Başlık"
      rules="required"
    >
      <b-form-input
        id="title_content"
        v-model="dataItem.title_content"
        placeholder="İçerik Başlık"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup, BFormInput,
} from 'bootstrap-vue'
import { required } from '@validations'

export default {
  name: 'TitleContent',
  components: {
    BFormGroup,
    BFormInput,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['brands/dataItem']
    },
  },
  created() {
    localize('tr')
  },
}
</script>
